import { Badge } from "@/common/badge";
import { EBadgeType } from "@/common/badge/badge-helpers";
import { Button } from "@/common/button";
import { EButtonType } from "@/common/button/button-models";
import { InputCheckbox } from "@/common/input/checkbox";
import { ECheckboxType } from "@/common/input/checkbox/checkbox-models";
import { PopupBackground } from "@/common/popups/common/popup-background";
import React from "react";

export const PopupWarningGlobalFM = React.memo(
  function PopupWarningGlobalFM(props: { onUnderstand: () => void }) {
    const [isShowWhy, setIsShowWhy] = React.useState(false);
    const [isChecked, setIsChecked] = React.useState(false);

    return (
      <PopupBackground>
        <div className="mt-5">
          {isShowWhy ? (
            <>
              <h4 className="mb-5 text-center text-heading font-bold text-body-text">
                Why do we do this?
              </h4>

              <p className="mb-5 text-center text-body-lg font-normal text-body-text">
                This is to protect you and your fellow creators earnings.
              </p>
              <p className="mb-5 text-center text-body-lg font-normal text-body-text">
                If you take bonus chats out of Alua, the creators who referred
                them lose commission.
              </p>
              <p className="mb-5 text-center text-body-lg font-normal text-body-text">
                Creators found breaking these rules will be removed from the
                featured screen.
              </p>

              <div className="mt-5">
                <Button
                  buttonType={EButtonType.BlueWide}
                  onClick={() => setIsShowWhy(false)}
                >
                  Back
                </Button>
              </div>
            </>
          ) : (
            <>
              <h4 className="mb-5 text-center text-heading font-bold text-body-text">
                Featured Screen Rules
              </h4>

              <p className="mb-5 text-center text-body-lg font-normal text-body-text">
                To keep Alua fair for our creators please be advised that taking{" "}
                <Badge type={EBadgeType.Bonus} /> customers to other apps
                (including messaging apps) is not allowed.
              </p>
              <p className="mb-5 text-center text-body-lg font-normal text-body-text">
                <Badge type={EBadgeType.Bonus} /> customers are a bonus income
                source from our featured screen.
              </p>

              <p className="mb-5 text-center text-body-lg font-normal text-body-text">
                Don’t worry! - this rule does not apply to your own fans you
                bring in.
              </p>

              <div className="mt-5 mb-5">
                <Button
                  buttonType={EButtonType.BlueLink}
                  onClick={() => setIsShowWhy(true)}
                >
                  Why do we do this?
                </Button>
              </div>

              <div className="mt-5 mb-5">
                <InputCheckbox
                  name="understand-PopupWarningGlobalFM"
                  value={isChecked ? "on" : "off"}
                  label="I understand & agree"
                  checkboxConfig={{ type: ECheckboxType.Box }}
                  onChange={(name, value) => setIsChecked(value === "on")}
                />
              </div>

              <div className="mt-5">
                <Button
                  buttonType={EButtonType.BlueWide}
                  onClick={props.onUnderstand}
                  isDisabled={!isChecked}
                >
                  Continue
                </Button>
              </div>
            </>
          )}
        </div>
      </PopupBackground>
    );
  }
);
